export default "__VITE_ASSET__B5$4V800__"